import { ErrorBoundary } from "react-error-boundary";
import PageNotFound from "./pages/PageNotFound";

function ErrorFallback({ error }) {
  return <></>;
  // return (
  //   <div>
  //     <PageNotFound />
  //   </div>
  // );
}

function AppErrorBoundary({ children }) {
  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onError={(error) => {
        const hasReloaded = sessionStorage.getItem("hasReloaded");
        console.error(error);
        if (!hasReloaded) {
          sessionStorage.setItem("hasReloaded", "true");
          window.location.reload();
        }
      }}>
      {children}
    </ErrorBoundary>
  );
}
export default AppErrorBoundary;
